import {Controller, useFormContext} from 'react-hook-form';
import * as React from 'react';
import {CheckboxProps, FormControl, FormControlLabel, FormGroup, FormHelperText} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

export function MuiRhfCheckbox(props: {
  name: string,
  label: string
} & Partial<Omit<CheckboxProps, 'onChange' | 'onBlur' | 'value' | 'name'>>) {
  const {name, label, required, ...rest} = props;
  const {control} = useFormContext<any>();

  return (
    <Controller
      name={name}
      control={control}
      render={renderProps =>
        <FormControl error={!!renderProps.fieldState.error} fullWidth={true} required={props.required || false} id={'select_' + name}>
          <FormGroup aria-label="position" row>
            <FormControlLabel
              label={label + (required ? ' *' : '')}
              value={renderProps.field.value as any}
              labelPlacement="start"
              control={
                <Checkbox
                  name={renderProps.field.name}
                  onChange={(event) => renderProps.field.onChange(event.target.checked)}
                  onBlur={renderProps.field.onBlur}
                  checked={(renderProps.field.value as any) || false}
                  {...rest}
                />
              }
            />
            <FormHelperText>{renderProps.fieldState.error?.message}</FormHelperText>
          </FormGroup>
        </FormControl>
      }
    />
  );
}
